/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useResourcesQuery as useResourcesQueryDeployments } from '@modules/role-assignments-lib/resource_query_provider/user-deployments'
import { useResourcesQuery as useResourcesQueryElasticsearch } from '@modules/role-assignments-lib/resource_query_provider/user-elasticsearch-projects'
import { useResourcesQuery as useResourcesQueryObservability } from '@modules/role-assignments-lib/resource_query_provider/user-observability-projects'
import { useResourcesQuery as useResourcesQuerySecurity } from '@modules/role-assignments-lib/resource_query_provider/user-security-projects'
import { useResourcesQuery as useResourcesQueryConnectedClusters } from '@modules/role-assignments-lib/resource_query_provider/user-connected-clusters'
import type { ResourceQueryResult } from '@modules/role-assignments-lib/types'

import type { UseQueryOptions } from 'react-query'

export const useGetUserResourcesQuery = (
  options?: Pick<UseQueryOptions, 'enabled'>,
): ResourceQueryResult[] => {
  const enabled = options?.enabled

  const queryResults: ResourceQueryResult[] = [
    useResourcesQueryDeployments({ enabled }),
    useResourcesQueryElasticsearch({ enabled }),
    useResourcesQueryObservability({ enabled }),
    useResourcesQuerySecurity({ enabled }),
    useResourcesQueryConnectedClusters({ enabled }),
  ]

  return queryResults.filter(({ isEnabled }) => isEnabled)
}
